<template>
	<div class="sku-log-page">
		<section class="filter-card">
			<el-form inline size="small" class="filter-form" label-width="0" @submit.native.prevent="onSearch">
				<el-form-item class="keyword-item">
					<span class="keyword-label">关键字</span>
					<el-input
						v-model="keyword"
						placeholder="Sku编号、外部编码"
						clearable
						class="keyword-input"
						@keyup.enter.native="onSearch"
					/>
				</el-form-item>
				<div class="filter-actions">
					<el-button type="primary" class="btn-search" @click="onSearch">搜索</el-button>
				</div>
			</el-form>
		</section>

		<section class="table-card" ref="tableCard">
			<el-table
				v-loading="loading"
				:data="displayList"
				border
				size="small"
				class="sku-log-table"
				:height="tableHeight"
				:row-class-name="tableRowClassName"
			>
				<el-table-column label="图片" width="76" align="center">
					<template slot-scope="scope">
						<div class="sku-pic">
							<img v-if="skuOf(scope.row).thumb_url" :src="skuOf(scope.row).thumb_url" alt="">
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Sku编号|外部编码" min-width="148" align="center">
					<template slot-scope="scope">
						<div class="sku-code-cell">
							<template v-if="skuOf(scope.row).sku_id || skuOf(scope.row).spec_desc">
								<div v-if="skuOf(scope.row).sku_id">{{ skuOf(scope.row).sku_id }}</div>
								<div v-if="skuOf(scope.row).spec_desc">{{ skuOf(scope.row).spec_desc }}</div>
							</template>
							<span v-else>-</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Sku状态" width="88" align="center">
					<template slot-scope="scope">
						<span :class="skuStatusClass(scope.row)">{{ formatSkuStatus(scope.row) }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column label="同步库存" min-width="120" align="center">
					<template slot-scope="scope">{{ formatStockSync(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="编辑状态" width="96" align="center">
					<template slot-scope="scope">{{ formatEditStatus(scope.row) }}</template>
				</el-table-column>-->
				<el-table-column label="拼团价/单买价" width="108" align="center">
					<template slot-scope="scope">{{ formatPricePair(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="原库存" width="72" align="center">
					<template slot-scope="scope">{{ formatNumber(skuOf(scope.row).quantity) }}</template>
				</el-table-column>
				<el-table-column prop="out_sku_sn" label="Sku名称" min-width="140" align="center">
					<template slot-scope="scope">{{ skuOf(scope.row).out_sku_sn || '-' }}</template>
				</el-table-column>
				<el-table-column label="同步推送价" width="108" align="center">
					<template slot-scope="scope">{{ formatSyncPrice(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="推送库存" width="80" align="center">
					<template slot-scope="scope">{{ formatNumber(scope.row.quantity) }}</template>
				</el-table-column>
				<el-table-column label="同步结果" width="88" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.stock_state === 2" class="sync-ok">成功</span>
						<span v-else-if="scope.row.stock_state === 3" class="sync-fail">失败</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="失败原因" min-width="180" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.stock_err_msg" class="err-msg">{{ scope.row.stock_err_msg }}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="数据更新时间" min-width="138" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.data_update_time) }}</template>
				</el-table-column>
			</el-table>
		</section>

		<section class="pager-card">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page.sync="page"
				:page-size="pageSize"
				:total="total"
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
			/>
		</section>
	</div>
</template>

<script>
export default {
	name: 'PddGoodsSkuLog',
	inject: {
		retailShop: { default: null },
		getSyncTaskId: {
			default: function() {
				return 0
			},
		},
	},
	data() {
		return {
			list: [],
			page: 1,
			pageSize: 10,
			total: 0,
			loading: false,
			keyword: '',
			tableHeight: 480,
		}
	},
	computed: {
		productId() {
			return (this.retailShop && this.retailShop.skuLogProductId) || ''
		},
		displayList() {
			var keyword = (this.keyword || '').trim()
			if (!keyword) {
				return this.list
			}
			return this.list.filter(this.matchKeyword)
		},
	},
	watch: {
		productId: {
			immediate: true,
			handler(id) {
				if (id) {
					this.page = 1
					this.fetchList()
				}
			},
		},
	},
	mounted() {
		this.calcTableHeight()
		window.addEventListener('resize', this.calcTableHeight)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calcTableHeight)
	},
	methods: {
		onSearch() {
			this.page = 1
			this.fetchList()
		},
		skuOf(row) {
			if (!row) {
				return {}
			}
			return row.retail_shop_product_sku || row
		},
		matchKeyword(row) {
			var keyword = (this.keyword || '').trim()
			if (!keyword) {
				return true
			}
			var sku = this.skuOf(row)
			var text = [
				sku.sku_id,
				sku.out_sku_sn,
			].filter(function(item) {
				return item != null && item !== ''
			}).join(' ')
			return text.indexOf(keyword) !== -1
		},
		handleCurrentChange() {
			this.fetchList()
		},
		handleSizeChange(val) {
			this.page = 1
			this.pageSize = val
			this.fetchList()
		},
		calcTableHeight() {
			this.$nextTick(function() {
				var card = this.$refs.tableCard
				if (!card) {
					return
				}
				var h = card.getBoundingClientRect().height
				this.tableHeight = h > 360 ? Math.floor(h) : 360
			}.bind(this))
		},
		parseListResponse(data) {
			if (!data) {
				return { list: [], count: 0 }
			}
			if (Array.isArray(data)) {
				return { list: this.mapLogList(data), count: data.length }
			}
			var rawList = data.list || data.sku_list || data.logs || data.records || []
			return {
				list: this.mapLogList(rawList),
				count: data.count != null ? data.count : (data.total_count != null ? data.total_count : (data.total || 0)),
			}
		},
		mapLogList(list) {
			if (!Array.isArray(list)) {
				return []
			}
			return list.map(function(item) {
				if (!item || !item.retail_shop_product_sku) {
					return item
				}
				var sku = item.retail_shop_product_sku
				var logDataUpdateTime = item.data_update_time != null && item.data_update_time !== ''
					? item.data_update_time
					: item.create_time
				return Object.assign({}, sku, {
					create_time: item.create_time,
					data_in_time: item.data_in_time,
					data_update_time: logDataUpdateTime,
					group_price: item.group_price,
					single_price: item.single_price,
					// 顶层 quantity = 日志推送库存（覆盖 sku.quantity，原库存仍从 retail_shop_product_sku 取）
					quantity: item.quantity,
					stock_state: item.stock_state,
					stock_err_msg: item.stock_err_msg,
					price_state: item.price_state,
					price_err_msg: item.price_err_msg,
					retail_shop_product_sku: sku,
				})
			})
		},
		fetchList() {
			if (!this.productId) {
				this.list = []
				this.total = 0
				return
			}
			var params = {
				retail_shop_product_id: Number(this.productId),
				page: this.page,
				limit: this.pageSize,
			}
			this.loading = true
			this.$axios.post('api/retail_goods/sync_sku_logs', params).then(function(res) {
				if (res.data.code == 0) {
					var parsed = this.parseListResponse(res.data.data)
					this.list = parsed.list
					this.total = parsed.count
				} else {
					this.$message.error(res.data.message || '获取Sku更新记录失败')
				}
			}.bind(this)).catch(function(err) {
				console.log(err)
				this.$message.error('获取Sku更新记录失败')
			}.bind(this)).finally(function() {
				this.loading = false
				this.calcTableHeight()
			}.bind(this))
		},
		tableRowClassName: function(param) {
			if (param.row && param.row.stock_state === 3) {
				return 'sync-fail-row'
			}
			return ''
		},
		formatSkuStatus(row) {
			var sku = this.skuOf(row)
			if (!sku) {
				return '-'
			}
			if (sku.is_onsale != null && sku.is_onsale !== '') {
				var status = Number(sku.is_onsale)
				if (status === 1) return '上架'
				if (status === 0) return '下架'
			}
			return '-'
		},
		skuStatusClass(row) {
			var text = this.formatSkuStatus(row)
			if (text === '上架') return 'status-on'
			if (text === '下架') return 'status-off'
			return ''
		},
		formatStockSync(row) {
			var sku = this.skuOf(row)
			if (!sku) {
				return '-'
			}
			if (sku.is_sync == 1) return '同步(随商品配置)'
			if (sku.is_sync == 0) return '不同步'
			return '-'
		},
		formatEditStatus(row) {
			var sku = this.skuOf(row)
			if (!sku) {
				return '-'
			}
			if (sku.is_edited == 1) return '已修改'
			if (sku.is_edited == 0) return '未修改过'
			return '-'
		},
		formatPricePair(row) {
			var sku = this.skuOf(row)
			if (!sku) {
				return '-'
			}
			var groupPrice = sku.multi_price
			var singlePrice = sku.price
			if (groupPrice == null && singlePrice == null) {
				return '-'
			}
			return this.formatPriceFromCent(groupPrice) + '/' + this.formatPriceFromCent(singlePrice)
		},
		formatSyncPrice(row) {
			var groupPrice = row.group_price
			var singlePrice = row.single_price
			if (groupPrice == null && singlePrice == null) {
				return '-'
			}
			return this.formatPriceFromCent(groupPrice) + '/' + this.formatPriceFromCent(singlePrice)
		},
		formatPriceFromCent(value) {
			if (value == null || value === '') {
				return '-'
			}
			var yuan = Number(value) / 100
			if (isNaN(yuan)) {
				return '-'
			}
			return yuan.toFixed(2)
		},
		formatNumber(value) {
			if (value == null || value === '') {
				return '0'
			}
			return String(value)
		},
		formatTime(value) {
			if (value == null || value === '') {
				return '-'
			}
			if (typeof value === 'string' && value.indexOf('-') !== -1) {
				return this.$moment(value).format('YYYY-MM-DD HH:mm:ss')
			}
			return this.$moment.unix(Number(value)).format('YYYY-MM-DD HH:mm:ss')
		},
	},
}
</script>

<style scoped lang="less">
.sku-log-page {
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-height: 100%;
	padding: 12px 14px 16px;
	box-sizing: border-box;
}

.filter-card,
.table-card,
.pager-card {
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
}

.filter-card {
	padding: 10px 14px 8px;
	flex-shrink: 0;
}

.filter-form {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
}

.keyword-item {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 0;
}

.keyword-label {
	font-size: 12px;
	color: #606266;
	white-space: nowrap;
}

.keyword-input {
	width: 260px;
}

.filter-actions {
	display: flex;
	align-items: center;
	margin-left: auto;
}

.btn-search {
	background: linear-gradient(135deg, #ff6b3d 0%, #ff4714 100%) !important;
	border: none !important;
}

.table-card {
	flex: 1;
	min-height: 0;
	padding: 10px 12px;
}

.sku-log-table {
	width: 100%;
}

.sku-pic {
	width: 52px;
	height: 52px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
}

.sku-code-cell {
	line-height: 1.4;
	white-space: normal;
	word-break: break-all;
}

.status-on {
	color: #059669;
}

.status-off {
	color: #6b7280;
}

.sync-ok {
	color: #059669;
}

.sync-fail,
.err-msg {
	color: #DC2626;
}

.err-msg {
	font-size: 12px;
	line-height: 1.4;
	word-break: break-all;
}

.pager-card {
	flex-shrink: 0;
	padding: 6px 12px 8px;
	display: flex;
	justify-content: flex-start;
}
</style>

<style lang="less">
.sku-log-page .sync-fail-row {
	background-color: #FEF0F0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/pddGoodsSkuLog.vue